<div #popUpContent style="display: none">
  <iframe
    src="https://player.vimeo.com/video/927530049?h=6bffe467cf&badge=0&autopause=0&player_id=0&app_id=58479"
    width="100%"
    height="230"
    frameborder="0"
    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    title="Představení pedagogické diagnostiky iSophi"
  ></iframe>
</div>
